export default function passwordValidator(value) {
  return `${value}`.length >= 8 && `${value}`.match(/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/);
}
